import {
  GENERAL_SEARCH_TERMS,
  SECTION_TO_SEARCH_TERMS
} from 'modules/search/constants'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import { capitalizeStringUtil } from 'packages/src'
import useIntl from 'modules/component/utils/hooks/useIntl'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import updateSearchAction from 'modules/search/actions/update-search/index.js'
import formatMessageIntlUtil from 'modules/intl/utils/format-message/index.js'
import Row from 'components/Row.js'
import { ChipPressable } from 'components/ChipPressable/index.js'
import { View } from 'components/View.js'
import logEventAnalyticsUtil from 'modules/analytics/utils/log-event/index.js'

const ANALYTIC_EVENT = {
  SELECT_SEARCH_SUGGESTION: 'SELECT_SEARCH_SUGGESTION'
}

/**
 * @param section
 * @param onSubmit
 * @returns {JSX.Element}
 * @constructor
 */
export function SearchPageSuggestions ({
  section,
  onSubmit
}) {
  const dispatch = useDispatch()
  const intl = useIntl()
  const suggestions = SECTION_TO_SEARCH_TERMS[section] || GENERAL_SEARCH_TERMS
  const query = useSelector(getQuerySearchSelect)

  if (!suggestions) {
    return <></>
  }

  const handlePressTagSearch = (query) => {
    dispatch(updateSearchAction(query))
    logEventAnalyticsUtil(ANALYTIC_EVENT.SELECT_SEARCH_SUGGESTION, {
      query: query,
      section: section
    })
    onSubmit(query)
  }

  return (
    <Row
      mt
      style={{
        overflowX: 'scroll',
        wordBreak: 'keep-all',
        flexWrap: 'wrap'
      }}
    >
      {
        suggestions.map(suggestionMessage => {
          const suggestion = formatMessageIntlUtil(intl, suggestionMessage)
          const handlePress = () => {
            handlePressTagSearch(suggestion)
          }

          return (
            <View
              mt
              mr
              key={suggestion}
            >
              <ChipPressable
                onClick={handlePress}
                style={{
                  width: 'auto'
                }}
                isSelected={query === suggestion}
                label={capitalizeStringUtil(suggestion)}
              />
            </View>
          )
        })
      }
    </Row>
  )
}
